(function () {
  'use strict';

  const BREAKPOINT = 768;
  const NAV_ITEM = '.custom-nav__item--has-dropdown';
  const DROPDOWN = '.custom-mega-dropdown';
  const TRIGGER = '.custom-nav__link';
  const IS_OPEN = 'is-open';

  function isMobile() {
    return window.innerWidth < BREAKPOINT;
  }

  // ============================================
  // ARIA — desktop hover sync
  // ============================================
  function initDesktopAria() {
    document.querySelectorAll(NAV_ITEM).forEach(item => {
      const dropdown = item.querySelector(DROPDOWN);
      const trigger = item.querySelector(TRIGGER);
      if (!dropdown || !trigger) return;

      item.addEventListener('mouseenter', () => {
        if (isMobile()) return;
        dropdown.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('mouseleave', () => {
        if (isMobile()) return;
        dropdown.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
      });

      // Escape key closes dropdown
      dropdown.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          dropdown.setAttribute('aria-hidden', 'true');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
    });
  }

  // ============================================
  // MOBILE — tap open / close
  // ============================================
  function initMobile() {
    document.querySelectorAll(NAV_ITEM).forEach(item => {
      const dropdown = item.querySelector(DROPDOWN);
      const trigger = item.querySelector(TRIGGER);
      const inner = dropdown?.querySelector('.custom-mega-dropdown__inner');
      if (!dropdown || !trigger || !inner) return;

      // Inject close button once
      if (!dropdown.querySelector('.custom-mega-dropdown__close')) {
        const closeWrap = document.createElement('div');
        closeWrap.className = 'custom-mega-dropdown__close';
        closeWrap.innerHTML = '<button class="custom-mega-dropdown__close-btn" aria-label="Close menu">&times;</button>';
        inner.prepend(closeWrap);

        closeWrap.querySelector('.custom-mega-dropdown__close-btn').addEventListener('click', () => {
          closePanel(dropdown, trigger);
        });
      }

      // Tap trigger on mobile
      trigger.addEventListener('click', e => {
        if (!isMobile()) return;
        e.preventDefault();
        openPanel(dropdown, trigger);
      });
    });
  }

  function openPanel(dropdown, trigger) {
    document.body.style.overflow = 'hidden';
    dropdown.classList.add(IS_OPEN);
    dropdown.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closePanel(dropdown, trigger) {
    document.body.style.overflow = '';
    dropdown.classList.remove(IS_OPEN);
    dropdown.setAttribute('aria-hidden', 'true');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  // ============================================
  // CLOSE ALL — shared utility
  // ============================================
  function closeAll() {
    document.querySelectorAll(`${DROPDOWN}.${IS_OPEN}`).forEach(el => {
      const trigger = el.closest(NAV_ITEM)?.querySelector(TRIGGER);
      closePanel(el, trigger);
    });
  }

  // ============================================
  // ESCAPE KEY — global
  // ============================================
  function initEscape() {
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeAll();
    });
  }

  // ============================================
  // LINK CLICK — close on navigate
  // ============================================
  function initLinkClose() {
    document.querySelectorAll(`${DROPDOWN} a`).forEach(link => {
      link.addEventListener('click', closeAll);
    });
  }

  // ============================================
  // RESIZE — clean up on breakpoint cross
  // ============================================
  function initResize() {
    let timer;
    window.addEventListener('resize', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        closeAll();
        document.body.style.overflow = '';
      }, 200);
    });
  }

  // ============================================
  // INIT
  // ============================================
  function init() {
    initDesktopAria();
    initMobile();
    initEscape();
    initLinkClose();
    initResize();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();